import React, { useState } from "react";
import { Box, Button, Collapse } from "@mui/material";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { PropTypes } from "prop-types";
import { useTranslation } from "react-i18next";

const ExpandableFilters = ({ staticContent, expandableContent }) => {
  const { t } = useTranslation();

  const [filterMenuExpanded, setFilterMenuExpanded] = useState(false);

  const handleSetFilterMenuExpanded = () => {
    setFilterMenuExpanded(!filterMenuExpanded);
  };

  return (
    <Box display="flex" flexDirection="column" flexWrap="wrap">
      <Box display="flex" flexDirection={{ xs: "column", sm: "row" }}>
        {staticContent}
        <Box
          display="flex"
          justifyContent={{ xs: "flex-end", sm: "flex-start" }}
          alignItems="center"
          ml={{ xs: 0, sm: 2 }}
          mt={{ xs: 2, sm: 0 }}
        >
          <Button
            data-qa="expandable-filters-expand-btn"
            color="primary"
            endIcon={filterMenuExpanded ? <ArrowDropUp /> : <ArrowDropDown />}
            onClick={handleSetFilterMenuExpanded}
          >
            {t("expandFiltersBtn")}
          </Button>
        </Box>
      </Box>

      <Collapse in={filterMenuExpanded}>
        <Box display="flex" flex={1} mt={2}>
          {expandableContent}
        </Box>
      </Collapse>
    </Box>
  );
};

export default ExpandableFilters;

ExpandableFilters.propTypes = {
  /**
   * Should contain the filters that will always be visible
   */
  staticContent: PropTypes.node,
  /**
   * Contains the filters in the expandable section
   */
  expandableContent: PropTypes.node
};
